/**
 * <s-sticky-buy> shows a fixed buy bar once the main product form has scrolled
 * above the viewport. Its submit button targets the main form by `form` id, so
 * the selected variant and pack are always the ones added to the cart. The
 * price row is mirrored from the live buy box each time the bar appears.
 */
class StickyBuy extends HTMLElement {
  connectedCallback() {
    const targetId = this.dataset.target;
    const priceSource = this.dataset.priceSource;
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    this.observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (passed) this.syncPrice(priceSource);
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
    });
    this.inert = true;
    this.observer.observe(target);
  }

  syncPrice(selector) {
    const slot = this.querySelector('[data-sticky-price]');
    const source = selector ? document.querySelector(selector) : null;
    if (slot && source) slot.innerHTML = source.innerHTML;
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', StickyBuy);
